import dayjs from 'dayjs';
import { useMemo, useState } from 'react';
import { getWeekDays } from '../../../../helpers/date-time';
import { useLang } from '../../../../hooks/use-lang';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { EmployeeType } from '../../../../store/api/employees-api';
import { SchedulerType } from '../../../../store/api/scheduler-api';
import { useBranchesStore } from '../../../../store/use-branch-store';
import { useEmployeesStore } from '../../../../store/use-employee-store';
import { useSchedulerStore } from '../../../../store/use-scheduler-store';

export const useTasksPlannerUtils = () => {
  const { t, getLocale } = useLang();
  const { isLoading, list, deleteScheduler, pagination } = useSchedulerStore();
  const { staff } = useEmployeesStore();
  const { place } = useBranchesStore();
  const weekDays = getWeekDays();

  const branches = useMemo(
    () => place?.map((item) => ({ id: String(item.id), value: getLocale(item.name) })) || [],
    [getLocale, place],
  );

  const [editableModal, setEditableModal] = useState<SchedulerType>();
  const [deletableModal, setDeletableModal] = useState<SchedulerType>();

  const { addQueryParams } = useQueryParams();

  const getEmployees = (staff?: EmployeeType[], staffIds?: number[]) => {
    return staff?.filter((employee) => staffIds?.includes(employee.id));
  };

  const getEmployeeNames = (employees?: EmployeeType[]) => {
    return employees
      ?.map((employee) => `${getLocale(employee.name)} ${getLocale(employee.surname)}`)
      .join(', ');
  };

  const getDaysOfWeek = (days?: boolean[], weekDays?: string[]) => {
    return days
      ?.map((isOn, index) => (isOn ? weekDays?.[index] : undefined))
      .filter(Boolean)
      .join(', ');
  };

  const getSpecialDays = (dates?: string[]) => {
    return dates?.map((date) => dayjs(new Date(date)).format('DD.MM.YYYY')).join(', ');
  };

  return {
    pagination,
    isLoading,
    list,
    branches,
    t,
    getLocale,
    weekDays,
    staff,
    editableModal,
    setEditableModal,
    deletableModal,
    setDeletableModal,
    deleteScheduler,
    addQueryParams,
    getEmployees,
    getEmployeeNames,
    getDaysOfWeek,
    getSpecialDays,
  };
};
